export interface ScannerStockDetails {
  stockNo: string;
  productKey: string;
  batchNo: string;
  balance: number;
  grade?: string;
  dateIntoStock?: Date;
}
